import { EventEmitter } from '@angular/core';
import { LinksButtonModel } from '../../../Shared/components/Links/links-button.model';
import { LinksButtonTypesEnum } from '../../../Shared/components/Links/links-button-types.enum';

export const storyLinksButton: LinksButtonModel[] = [
    {
        buttonClick: new EventEmitter(),
        iconClasses: 'fa-regular fa-duotone fa-trash-can',
        disabled: false,
        type: LinksButtonTypesEnum.Delete
    },
    {
        buttonClick: new EventEmitter(),
        iconClasses: 'fa-regular fa-duotone fa-pen',
        disabled: false,
        type: LinksButtonTypesEnum.Edit
    },
    {
        buttonClick: new EventEmitter(),
        iconClasses: 'fa-regular fa-duotone fa-plus',
        disabled: false,
        type: LinksButtonTypesEnum.Add
    },

];
